import ButtonDialog from "default/components/ButtonDialog";
import StyledButton from "default/components/StyledButton";

const HIGHLIGHT_BUTTON_COLOR = "#910000";

const ResetMemorySection = ({
  resetMemory,
  t,
  buttonLabel,
  highlight = false,
  mode = "reset",
}) => {
  const isRestart = mode === "restart";
  const confirmTitle = isRestart
    ? t("higurashi:button.dialog.restart_confirm")
    : t("higurashi:button.dialog.reset_memories_confirm");
  const confirmDescription = isRestart
    ? t("higurashi:button.description.restart_confirm")
    : undefined;
  const confirmWarnings = isRestart
    ? undefined
    : t("higurashi:button.warning.reset_memories", {
        returnObjects: true,
      });
  const confirmButtonLabel = isRestart
    ? t("higurashi:button.restart")
    : t("common:button.reset");

  return (
    <>
      <StyledButton
        variant="contained"
        onClick={resetMemory.handlers.onClickReset}
        sx={(theme) => ({
          marginTop: 4,
          background: highlight ? HIGHLIGHT_BUTTON_COLOR : "transparent",
          borderColor: highlight ? HIGHLIGHT_BUTTON_COLOR : undefined,
          color: highlight ? theme.system.colors.text.primary : undefined,
          "&:hover": {
            background: highlight ? HIGHLIGHT_BUTTON_COLOR : "transparent",
            borderColor: highlight ? HIGHLIGHT_BUTTON_COLOR : undefined,
          },
        })}
      >
        {buttonLabel || t("common:button.reset_memories")}
      </StyledButton>

      <ButtonDialog
        open={resetMemory.dialogStates.openConfirm}
        title={confirmTitle}
        description={confirmDescription}
        warnings={confirmWarnings}
        buttons={[
          {
            label: confirmButtonLabel,
            onClick: resetMemory.handlers.onClickConfirm,
          },
        ]}
        handleClose={resetMemory.handlers.onClickClose}
      />

      <ButtonDialog
        open={resetMemory.dialogStates.openNotice}
        title={t("common:button.dialog.cannot_reset_memories")}
        handleClose={resetMemory.handlers.onClickClose}
        buttons={[
          {
            label: t("common:button.close"),
            onClick: resetMemory.handlers.onClickClose,
          },
        ]}
      />

      <ButtonDialog
        open={resetMemory.dialogStates.openExpiredNotice}
        title={t("common:button.dialog.expired_reset_unavailable")}
        handleClose={resetMemory.handlers.onClickClose}
        buttons={[
          {
            label: t("common:button.close"),
            onClick: resetMemory.handlers.onClickClose,
          },
        ]}
      />

      <ButtonDialog
        open={resetMemory.dialogStates.openError}
        title={t("common:button.dialog.reset_memories_fail")}
        buttons={[
          {
            label: t("common:button.close"),
            onClick: resetMemory.handlers.onClickClose,
          },
        ]}
        handleClose={resetMemory.handlers.onClickClose}
      />
    </>
  );
};

export default ResetMemorySection;
